import React, { useState } from "react";
import { TabMenu } from "primereact/tabmenu";
import Agent from "./Agent";
import ChatPOC from "./ChatPOC";
import "./style.css";

const AiAgent = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const items = [
    { label: "Agent", id: "agent" },
    { label: "POC", id: "poc" },
  ];
  Object.freeze(items);

  const renderTabContent = (itemId) => {
    switch (itemId) {
      case "agent":
        return <Agent />;
      case "poc":
        return <ChatPOC />;
      default:
        return <Agent />;
    }
  };

  return (
    <div className="ai-page">
      <div className="ai-tabs-bar">
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="ai-tabmenu"
        />
      </div>
      <div className="ai-tabcontent">{renderTabContent(items[activeIndex]?.id)}</div>
    </div>
  );
};

export default AiAgent;
